import { Graph } from 'graphlib';
import { AutomationActions } from '../actions/automationActions';
import {
  IAggregateAutomationStats,
  IAutomationAction,
  IAutomationActionToOpenOnReady,
  IAutomationStats,
  IAutomationExistingInputTriggers,
} from '../model/AutomationModel';

export interface IAutomationState {
  action?: IAutomationAction;
  actionToOpenOnReady?: IAutomationActionToOpenOnReady;
  reviewRequiredCount: number | null;
  graphLibInstance: Graph | undefined;
  busyStatsCampaignIds: number[];
  stats: Record<number, IAutomationStats>;
  aggregateStats: IAggregateAutomationStats;
  existingInputTriggers?: IAutomationExistingInputTriggers;
}

const initial = {
  action: undefined,
  actionToOpen: undefined,
  graphLibInstance: undefined,
  existingInputTriggers: undefined,
  busyStatsCampaignIds: [],
  reviewRequiredCount: null,
  stats: {},
  aggregateStats: {
    automationsCount: 0,
    contactsCount: 0,
    engagedCount: 0,
    finishedCount: 0,
    inAutomationCount: 0,
    inQueueCount: 0,
    messagesSentCount: 0,
    unsubscribedCount: 0,
  },
};

export const automation = (state: IAutomationState = initial, action) => {
  switch (action.type) {
    case AutomationActions.SHOW_ACTIONS_LIST:
      return {
        ...state,
        action: action.payload,
      };
    case AutomationActions.HIDE_ACTIONS_LIST:
      return {
        ...state,
        action: undefined,
      };
    case AutomationActions.SET_GRAPHLIB_INSTANCE:
      return {
        ...state,
        graphLibInstance: action.payload,
      };
    case AutomationActions.RESET_AUTOMATIONS_STATE:
      return initial;
    case AutomationActions.RETRIEVE_STATISTICS:
      return {
        ...state,
        busyStatsCampaignIds: Array.from(
          new Set(
            [...state.busyStatsCampaignIds, action?.payload?.campaignId].filter(
              Boolean,
            ),
          ),
        ),
      };
    case AutomationActions.RETRIEVE_STATISTICS_SUCCESS:
      return {
        ...state,
        busyStatsCampaignIds: state.busyStatsCampaignIds.filter(
          v => v !== action?.payload.campaignId,
        ),
        stats: {
          ...state.stats,
          [action?.payload.campaignId]: action.payload.stats,
        },
      };
    case AutomationActions.RETRIEVED_AGGREGATE_STATISTICS:
      return {
        ...state,
        aggregateStats: action.payload,
      };
    case AutomationActions.PUSH_ACTION_TO_OPEN:
      return {
        ...state,
        actionToOpenOnReady: action.payload,
      };
    case AutomationActions.REMOVE_ACTION_TO_OPEN: {
      if (state.actionToOpenOnReady?.widgetId === action.payload?.widgetId) {
        return {
          ...state,
          actionToOpenOnReady: undefined,
        };
      }
      return state;
    }
    case AutomationActions.INCREASE_REVIEW_REQUIRED: {
      return {
        ...state,
        reviewRequiredCount: Number(state.reviewRequiredCount) + 1,
      };
    }
    case AutomationActions.DECREASE_REVIEW_REQUIRED: {
      return {
        ...state,
        reviewRequiredCount: Number(state.reviewRequiredCount) - 1,
      };
    }
    case AutomationActions.SET_REVIEW_REQUIRED_COUNT: {
      return {
        ...state,
        reviewRequiredCount: action.payload,
      };
    }
    case AutomationActions.RETRIEVED_EXISTING_TRIGGERS: {
      return {
        ...state,
        existingInputTriggers: action.payload,
      };
    }

    default:
      return state;
  }
};
